export function compressImage(file, maxSizeMB = 0.17, maxWidthOrHeight = 1920) {
  return new Promise((resolve, reject) => {
    const targetSizeBytes = maxSizeMB * 1024 * 1024; // Convert MB to bytes
    
    if (file.size <= targetSizeBytes) {
      resolve(file)
      return
    }

    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = (event) => {
      const img = new Image()
      img.src = event.target.result
      
      img.onload = () => {
        let width = img.width
        let height = img.height

        // First pass: reduce dimensions if needed
        if (width > height) {
          if (width > maxWidthOrHeight) {
            height *= maxWidthOrHeight / width
            width = maxWidthOrHeight
          }
        } else {
          if (height > maxWidthOrHeight) {
            width *= maxWidthOrHeight / height
            height = maxWidthOrHeight
          }
        }

        const tryCompress = (w, h, minQuality = 0.1) => {
          return new Promise((res) => {
            const canvas = document.createElement('canvas')
            canvas.width = w
            canvas.height = h
            
            const ctx = canvas.getContext('2d')
            ctx.drawImage(img, 0, 0, w, h)

            let quality = 0.9
            let compressedDataUrl = canvas.toDataURL('image/jpeg', quality)

            // Reduce quality until we meet target or hit minimum quality
            while (compressedDataUrl.length > targetSizeBytes && quality > minQuality) {
              quality -= 0.05
              compressedDataUrl = canvas.toDataURL('image/jpeg', quality)
            }

            res({ dataUrl: compressedDataUrl, quality, width: w, height: h })
          })
        }

        const convertToFile = (dataUrl) => {
          return fetch(dataUrl)
            .then(res => res.blob())
            .then(blob => {
              return new File([blob], file.name.replace(/\.[^/.]+$/, '.jpg'), {
                type: 'image/jpeg',
                lastModified: Date.now()
              })
            })
        }

        // Recursive compression function - keeps trying until under target size
        const compressRecursive = (currentWidth, currentHeight, attempt = 1) => {
          return tryCompress(currentWidth, currentHeight, Math.max(0.01, 0.1 - (attempt * 0.02))).then(result => {
            // Check if still too large
            if (result.dataUrl.length > targetSizeBytes) {
              // If dimensions are already very small, stop to avoid unusable images
              if (currentWidth <= 100 || currentHeight <= 100) {
                console.warn(`[ImageCompressor] Cannot compress further. Final size: ${(result.dataUrl.length / 1024).toFixed(2)}KB`)
                return convertToFile(result.dataUrl)
              }
              
              // Reduce dimensions by 30% and try again
              const scaleDown = 0.7
              const newWidth = Math.max(50, Math.floor(currentWidth * scaleDown))
              const newHeight = Math.max(50, Math.floor(currentHeight * scaleDown))
              
              console.log(`[ImageCompressor] Attempt ${attempt}: Still too large (${(result.dataUrl.length / 1024).toFixed(2)}KB), reducing dimensions to ${newWidth}x${newHeight}`)
              
              return compressRecursive(newWidth, newHeight, attempt + 1)
            } else {
              console.log(`[ImageCompressor] Success on attempt ${attempt}: ${(result.dataUrl.length / 1024).toFixed(2)}KB at ${result.width}x${result.height}, quality: ${result.quality.toFixed(2)}`)
              return convertToFile(result.dataUrl)
            }
          })
        }

        // Start recursive compression
        compressRecursive(width, height).then(resolve).catch(reject)
      }
      
      img.onerror = reject
    }
    
    reader.onerror = reject
  })
}
